import _import from './_import';
import HomeIcon from '@/assets/images/menu/home.png';

export default [
  {
    path: '/',
    name: 'home',
    code: '0083',
    meta: {
      title: '首页',
      icon: HomeIcon,
      store: require('@/containers/Dashboard/store').default,
    },
    component: _import('HomePage/Home'),
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    code: '0079',
    meta: {
      title: '数据首页',
      store: require('@/containers/Dashboard/store').default,
    },
    component: _import('Dashboard/Dashboard'),
    hidden: true,
  },
];
